<template>
  <div class="common-page-outer" id="indexPageOuter">
    <div class="main-body">
      <div class="title-data">
        <div class="title">丽企之家政务端平台</div>
        <div>LIQIZHIJIAZHENGWUDUANPINGTAI</div>
        <!-- 欢迎来到，丽企之家{{ title }} -->
        <!-- <div class="calendar">
          <div class="month">{{ dates[1] }}</div>
          <div class="day">{{ dates[2] }}</div>
        </div>
        <div class="text">
          <div class="title">你好，{{ name }}</div>
          <div class="date">今天是{{ date.getMonth() + 1 }}月{{ dates[2] }}日</div>
        </div> -->
      </div>
      <home-title />
      <div
        class="body-content"
        :style="routeList.length > 8 ? 'height:auto;' : 'height:5.5rem;'"
      >
        <div v-if="isZzd" class="jurisdiction">暂无权限，请等待管理员审核</div>
        <div v-else class="content">
          <div
            class="list"
            v-for="(item, index) in activeList"
            :key="index"
            @click="listClick(item)"
          >
            <img
              :src="require(`@/assets/imagess/${item.name}@4x.png`)"
              alt=""
            />
            <div class="list-text">
              <b class="list-title">{{ item.name }}</b>
              <div>{{ modulesIntroduce[item.name] }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="body-bottom">
        <div>备案：浙ICP备12000333号-2浙公网安备 33010602004556号</div>
        <div class="text-top">
          建议使用1366*768分辨率/IE9.0或以上浏览器访问达到最佳效果
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import homeTitle from './homeTitle'
import { mapGetters } from 'vuex'
// import { urls } from './tempUrl'
import { getLocalStorage } from '../../utils/storage'
import { modulesIntroduce } from './constant'
export default {
  name: 'Dashboard',
  components: { homeTitle },
  data() {
    return {
      urls: [],
      loginName: 'admin',
      dates: [],
      date: new Date(),
      routeList: [],
      appHeaderRoutes: [],
      isZzd: false,
      creditCode: null,
      title: '企业端',
      dataSource: this.$store.state.user.userInfo.dataSource || '',
      modulesIntroduce: modulesIntroduce
    }
  },
  computed: {
    ...mapGetters(['name']),
    activeList() {
      return this.routeList.filter(item => {
        if (!this.dataSource) {
          return !['企业信息', '清廉之窗', '系统设置'].includes(item.name)
        } else {
          return !['清廉之窗'].includes(item.name)
        }
      })
    }
  },
  created() {
    // this.dataSource = this.$store.state.user.userInfo.dataSource || ''
    this.title = !this.dataSource ? '政务端' : '企业端'
    // 浙政钉人员登录显示  暂无权限，请等待管理员审核
    if (
      this.$store.state.user.userInfo.roleText === '浙政钉人员' ||
      this.$store.state.permission.appHeaderRoutes.length <= 0
    ) {
      this.isZzd = true
    } else {
      this.isZzd = false
      // if (!dataSource) {
      this.appHeaderRoutes = [...this.$store.state.permission.appHeaderRoutes]
      this.appHeaderRoutes.forEach(item => {
        item.sonMenu && this.routeList.push(...item.sonMenu)
      })
    }

    // console.log(this.routeList);
  },
  mounted() {
    this.dates = this.date.toDateString().split(' ')
    this.urls = JSON.parse(getLocalStorage('urls'))
    this.setRem()
    let that = this
    window.onresize = function() {
      that.setRem()
    }
  },
  methods: {
    /**
     * @description 适配
     */
    setRem() {
      let htmlWidth =
        document.documentElement.clientWidth || document.body.clientWidth
      // 得到html的Dom元素
      let htmlDom = document.getElementsByTagName('html')[0]
      // 设置根元素字体大小
      htmlDom.style.fontSize = 100 / (1920 / htmlWidth) + 'px'
    },
    /**
     * @description 显示图标
     */
    filterIconClass(item) {
      if (!item || !item.icon) return
      const type = item.icon.split(':')[0]
      let className = ''
      const name = item.icon.split(':')[1] || ''
      if (type == 'color') {
        className = name
      } else {
        // 线性
        className = `iconfont ${name}`
      }
      return className
    },
    filterIcons(item) {
      if (!item) return
      const type = item.split(':')[0]
      if (type == 'color') return true
      return false // 线性
    },
    listClick(item) {
      // console.log(item)
      this.$store.dispatch('permission/setCurrentRoue', item)
    }
  },
  beforeDestroy() {
    let htmlWidth =
      document.documentElement.clientWidth || document.body.clientWidth
    // 得到html的Dom元素
    let htmlDom = document.getElementsByTagName('html')[0]
    // 设置根元素字体大小
    htmlDom.style.fontSize = 14 + 'px'
  }
}
</script>
<style lang="scss" scoped>
.dashboard-container {
  width: 100%;
}
#indexPageOuter {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  justify-content: center;
  .main-body {
    width: 78%;
    .title-data {
      font-size: 9px;
      color: rgba(255, 255, 255, 100);
      letter-spacing: 0.07rem;
      .title {
        display: inline-block;
        margin-bottom: 0.1rem;
        font-size: 40px;
        color: rgba(255, 255, 255, 85);
        letter-spacing: 0.02rem;
      }
    }
    .body-content {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      // padding: 1rem 0.25rem 0;
      // background-color: rgba(255, 255, 255, 0.06);
      margin: 0.64rem 0 0;
      .jurisdiction {
        color: #fff;
        font-size: 38px;
        margin: 13% auto;
        letter-spacing: 3px;
      }
      .content {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        .list {
          display: flex;
          justify-content: space-around;
          flex-wrap: wrap;
          cursor: pointer;
          width: 350px;
          height: 180px;
          margin-right: 21px;
          margin-bottom: 20px;
          background: linear-gradient(
            rgba(0, 30, 32, 0.7) 0%,
            rgba(35, 190, 208, 0.5) 100%
          );
          border: 1px solid rgba(52, 226, 245, 1);
          box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);
          transition: all 0.3s ease-in-out;

          img {
            width: 105px;
            height: 120px;
            margin: auto 14px;
          }
          .list-text {
            flex: 3;
            letter-spacing: 1.5px;
            color: rgba(253, 255, 255, 0.8);
            font-size: 12px;
            line-height: 18px;
            margin-right: 22px;
            .list-title {
              display: inline-block;
              color: rgba(253, 255, 255, 0.9);
              font-size: 16px;
              margin-top: 18px;
              margin-bottom: 13px;
              letter-spacing: 1px;
            }
          }
        }
        .list:hover {
          // animation-name: hvr-wobble-vertical;
          // animation-timing-function: ease-in-out;
          // animation-iteration-count: 1;
          background: linear-gradient(
            rgba(26, 183, 193, 0.8) 0%,
            rgba(29, 83, 226, 0.8) 100%
          );
          transform: translateY(-10px);
        }
        @keyframes hvr-wobble-vertical {
          16.65% {
            transform: translateY(0.08rem);
          }

          33.3% {
            transform: translateY(-0.06rem);
          }

          49.95% {
            transform: translateY(0.04rem);
          }

          66.6% {
            transform: translateY(-0.02rem);
          }

          83.25% {
            transform: translateY(0.01rem);
          }

          100% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
          }
        }
      }
    }
    .body-bottom {
      width: 5.02rem;
      text-align: center;
      margin: 0.9rem auto 0;
      color: #fff;
      font-size: 0.12rem;
      line-height: 0.2rem;
    }
  }
  &::-webkit-scrollbar {
    width: 0.08rem;
    height: 0.08rem;
  }
  &::-webkit-scrollbar-track {
    background-color: #023049;
    border-radius: 2em;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(147, 153, 165, 0.4);
    border-radius: 2em;
  }
}
// .lists-0 {
//   background: url('~@/assets/imagess/bigIndex_qyfw.png') no-repeat top center;
//   background-size: 0.65rem;
// }

// .lists-1 {
//   background: url('~@/assets/imagess/bigIndex_qygl.png') no-repeat top center;
//   background-size: 0.55rem 0.61rem;
// }

// .lists-2 {
//   background: url('~@/assets/imagess/bigIndex_dnxt.png') no-repeat top center;
//   background-size: 0.55rem 0.65rem;
// }

// .lists-3 {
//   background: url('~@/assets/imagess/bigIndex_qygl.png') no-repeat top center;
//   background-size: 0.55rem 0.61rem;
// }

// .lists-4 {
//   background: url('~@/assets/imagess/bigIndex_cydt.png') no-repeat top center;
//   background-size: 0.57rem 0.64rem;
// }

// .lists-5 {
//   background: url('~@/assets/imagess/bigIndex_dagl.png') no-repeat top center;
//   background-size: 0.65rem;
// }

// .lists-6 {
//   background: url('~@/assets/imagess/bigIndex_mj.png') no-repeat top center;
//   background-size: 0.63rem 0.72rem;
// }

// .lists-7 {
//   background: url('~@/assets/imagess/bigIndex_dagl.png') no-repeat top center;
//   background-size: 0.65rem;
// }

// .lists-8 {
//   background: url('~@/assets/imagess/bigIndex_cydt.png') no-repeat top center;
//   background-size: 0.57rem 0.64rem;
// }

// .lists-9 {
//   background: url('~@/assets/imagess/bigIndex_cydt.png') no-repeat top center;
//   background-size: 0.57rem 0.64rem;
// }

// .lists-10 {
//   background: url('~@/assets/imagess/bigIndex_qygl.png') no-repeat top center;
//   background-size: 0.55rem 0.61rem;
// }

// .lists-11 {
//   background: url('~@/assets/imagess/bigIndex_qygl.png') no-repeat top center;
//   background-size: 0.55rem 0.61rem;
// }
// .lists-12 {
//   background: url('~@/assets/imagess/bigIndex_qygl.png') no-repeat top center;
//   background-size: 0.55rem 0.61rem;
// }
// .lists-13 {
//   background: url('~@/assets/imagess/bigIndex_cydt.png') no-repeat top center;
//   background-size: 0.57rem 0.64rem;
// }
// .lists-14 {
//   background: url('~@/assets/imagess/bigIndex_yxjc.png') no-repeat top center;
//   background-size: 0.71rem 0.71rem;
// }
// .lists-15 {
//   background: url('~@/assets/imagess/bigIndex_yxjc.png') no-repeat top center;
//   background-size: 0.71rem 0.71rem;
// }
</style>
